// UtileAdmin.jsx — Recharges des portefeuilles TeckiA Utile (chansons) et TeckiA Motion Vid (vidéos, 20 000 Ar la création)
// Paiements MVola / Orange Money déclarés par les clients -> validation (crédite le solde) ou refus (motif obligatoire,
// envoyé au client dans sa boîte de réception).

import React, { useState, useEffect, useCallback } from 'react';
import { Wrench, Loader2, RefreshCw, CheckCircle, XCircle } from 'lucide-react';
import { API_URL } from '../../config';
import PaymentMethodBadge from '../shared/PaymentMethodBadge';

const authHeaders = () => ({
  'Authorization': `Bearer ${localStorage.getItem('auth_token')}`,
  'Content-Type': 'application/json',
});

const METHOD_LABELS = { mvola: 'MVola', orange: 'Orange Money' };
const MODULES = [
  { key: 'utile', label: 'TeckiA Utile (chansons)', base: '/api/utile/admin/orders' },
  { key: 'motion', label: 'TeckiA Motion Vid (vidéos)', base: '/api/motion-vid/admin/orders' },
];
const FILTERS = [
  { key: 'pending', label: 'En attente' },
  { key: 'validated', label: 'Validés' },
  { key: 'rejected', label: 'Refusés' },
];

const fmtDate = (iso) => iso
  ? new Date(iso).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' })
  : '—';

function MotionStats({ onBack }) {
  const [st, setSt] = useState(null);
  const [err, setErr] = useState('');
  const load = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/api/motion-vid/admin/stats`, { headers: authHeaders() });
      const d = await res.json();
      if (d.success) { setSt(d.stats); setErr(''); } else setErr(d.message || 'Chargement impossible');
    } catch (e) { setErr('Chargement impossible'); }
  }, []);
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, [load]);
  const Box = ({ label, value, sub, warn }) => (
    <div className={`rounded-2xl border p-4 ${warn ? 'bg-amber-500/10 border-amber-400/40' : 'bg-white/5 border-white/10'}`}>
      <p className="text-xs text-blue-200">{label}</p><p className="text-2xl font-bold mt-1">{value}</p>{sub && <p className="text-[11px] text-gray-400 mt-0.5">{sub}</p>}
    </div>
  );
  return (
    <div className="p-4 md:p-8 text-white max-w-4xl">
      <div className="flex items-center justify-between gap-3 mb-6">
        <h1 className="text-2xl font-bold">Suivi TeckiA Motion Vid</h1>
        <button onClick={onBack} className="px-4 py-1.5 rounded-xl text-sm bg-white/10 hover:bg-white/20">← Recharges</button>
      </div>
      {err && <p className="mb-4 text-sm text-rose-300">{err}</p>}
      {!st ? <div className="py-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin" /></div> : (<>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
          <Box label="Disque libre" value={`${st.disk_free_gb} Go`} sub={`sur ${st.disk_total_gb} Go`} warn={st.disk_free_gb < 20} />
          <Box label="Occupé par Motion Vid" value={`${st.motion_mb} Mo`} sub={`${st.accounts} comptes · max ${st.quota_mb} Mo chacun`} />
          <Box label="File d'attente" value={st.queue} sub={`${st.rendering_now} rendu en cours · ~${st.avg_render_s}s par vidéo`} warn={st.queue >= 5} />
          <Box label="Créations aujourd'hui" value={st.created_today} sub={`≈ ${Number(st.revenue_today_ar).toLocaleString('fr-FR')} Ar (${Number(st.price_ar).toLocaleString('fr-FR')} Ar l'unité)`} />
        </div>
        {st.planner && (
          <div className={`rounded-2xl border p-4 mb-6 ${st.planner.mode === 'claude' ? 'bg-fuchsia-500/10 border-fuchsia-400/40' : 'bg-white/5 border-white/10'}`}>
            <div className="flex items-center justify-between gap-3 flex-wrap">
              <div>
                <p className="font-semibold">IA qui écrit les plans et les corrections : {st.planner.mode === 'claude' ? 'Claude Sonnet 5.5 (PAYANT, via Kie)' : 'gratuite (Gemma local, Groq, Gemini)'}</p>
                <p className="text-[11px] text-gray-400 mt-1">Claude : environ 0,015 $ (≈ 70 Ar) par plan ou correction. Aujourd&apos;hui : {st.planner.calls_today} appel(s), {st.planner.credits_today} crédits (≈ {(st.planner.credits_today * st.planner.usd_per_credit).toFixed(3)} $) sur un plafond de {st.planner.cap_credits} crédits/jour ; au-delà, retour automatique à l&apos;IA gratuite. Les autres tâches (voix, calage, ambiances) restent gratuites.</p>
              </div>
              <button disabled={!st.planner.kie_ready} onClick={async () => {
                const mode = st.planner.mode === 'claude' ? 'free' : 'claude';
                if (mode === 'claude' && !window.confirm('Activer Claude (PAYANT) pour les plans et corrections ? Chaque appel est facturé sur vos crédits Kie.')) return;
                const res = await fetch(`${API_URL}/api/motion-vid/admin/planner`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ mode }) });
                const d = await res.json(); if (d.success) load(); else setErr(d.message || 'Changement impossible');
              }} className="px-4 py-2 rounded-xl text-sm font-bold bg-white/10 hover:bg-white/20 disabled:opacity-40">{st.planner.mode === 'claude' ? 'Revenir à l’IA gratuite' : 'Activer Claude (payant)'}</button>
            </div>
          </div>)}
        <p className="text-xs text-gray-400 mb-3">Conservation : médias {st.media_days} jours, vidéos {st.video_days} jours. Réglable côté serveur (MOTION_VID_MEDIA_DAYS, MOTION_VID_VIDEO_DAYS, MOTION_VID_QUOTA_MB).</p>
        <h2 className="font-semibold mb-2">Comptes qui occupent le plus de place</h2>
        <div className="space-y-2">
          {st.top.map(r => (
            <div key={r.user_id} className="bg-white/5 border border-white/10 rounded-xl px-4 py-2.5 flex items-center justify-between gap-3">
              <span className="text-sm break-all">{r.email || r.user_id}</span>
              <span className="text-xs text-blue-200 whitespace-nowrap">{r.used_mb} Mo ({r.pct}%) · médias {r.media_mb} · vidéos {r.video_mb}</span>
            </div>))}
          {st.top.length === 0 && <p className="text-sm text-gray-400">Aucun compte.</p>}
        </div>
      </>)}
    </div>
  );
}

export default function UtileAdmin() {
  const [showStats, setShowStats] = useState(false);
  const [filter, setFilter] = useState('pending');
  const [mod, setMod] = useState('utile');
  const base = MODULES.find(m => m.key === mod).base;
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actingOn, setActingOn] = useState(null);
  const [error, setError] = useState('');
  const [counts, setCounts] = useState({ utile: 0, motion: 0 });     // recharges en attente par module (pastilles sur les onglets)

  const loadCounts = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/api/admin/pending-counts`, { headers: authHeaders() });
      const d = await res.json();
      const c = d.counts || d;
      setCounts({ utile: c.utile_orders || 0, motion: c.motion_orders || 0 });
    } catch (e) { /* les pastilles restent à leur dernière valeur */ }
  }, []);
  useEffect(() => { loadCounts(); const t = setInterval(loadCounts, 30000); return () => clearInterval(t); }, [loadCounts]);

  const load = useCallback(async () => {
    setLoading(true);
    loadCounts();
    try {
      const res = await fetch(`${API_URL}${base}?status=${filter}`, { headers: authHeaders() });
      const data = await res.json();
      if (data.success) setOrders(data.orders); else setError(data.message || 'Chargement impossible');
    } catch (e) { setError('Chargement impossible'); }
    finally { setLoading(false); }
  }, [filter, base, loadCounts]);

  useEffect(() => { load(); }, [load]);

  const validate = async (id) => {
    setActingOn(id); setError('');
    try {
      const res = await fetch(`${API_URL}${base}/${id}/validate`, { method: 'POST', headers: authHeaders() });
      const data = await res.json();
      if (!data.success) setError(data.message || 'Validation impossible');
      await load();
    } finally { setActingOn(null); }
  };

  const reject = async (id) => {
    const note = window.prompt('Raison du refus (envoyée au client dans sa messagerie) :', 'Paiement non retrouvé');
    if (note === null || !note.trim()) return;
    setActingOn(id); setError('');
    try {
      const res = await fetch(`${API_URL}${base}/${id}/reject`, {
        method: 'POST', headers: authHeaders(), body: JSON.stringify({ note: note.trim() }),
      });
      const data = await res.json();
      if (!data.success) setError(data.message || 'Refus impossible');
      await load();
    } finally { setActingOn(null); }
  };

  if (showStats) return <MotionStats onBack={() => setShowStats(false)} />;

  return (
    <div className="p-4 md:p-8 text-white max-w-4xl">
      <div className="flex items-center justify-between gap-3 mb-6">
        <h1 className="text-2xl font-bold flex items-center gap-2.5">
          <span className="w-10 h-10 rounded-2xl bg-gradient-to-br from-rose-500 to-amber-500 flex items-center justify-center"><Wrench className="w-5 h-5" /></span>
          Recharges — {mod === 'motion' ? 'TeckiA Motion Vid' : 'TeckiA Utile'}
        </h1>
        <button onClick={load} className="p-2.5 rounded-xl bg-white/10 hover:bg-white/20 transition" title="Actualiser">
          <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
        </button>
      </div>

      <p className="text-sm text-blue-200 mb-4">
        Valider crédite le portefeuille du montant payé (1 Ar payé = 1 Ar de solde). Une création de chanson ou de vidéo débite le prix fixé côté serveur (vidéo Motion Vid : 20 000 Ar, remboursée automatiquement si elle échoue).
      </p>

      <div className="flex gap-2 mb-3">
        {MODULES.map(m => (
          <button key={m.key} onClick={() => setMod(m.key)}
            className={`px-4 py-1.5 rounded-xl text-sm font-semibold border transition ${mod === m.key ? 'bg-fuchsia-500/30 border-fuchsia-400/60' : 'bg-white/5 border-white/10 text-gray-300 hover:bg-white/10'}`}>
            {m.label}
            {counts[m.key] > 0 && <span className="ml-2 inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-amber-400 text-[#1b1204] text-[11px] font-black">{counts[m.key]}</span>}
          </button>
        ))}
        <button onClick={() => setShowStats(true)} className="px-4 py-1.5 rounded-xl text-sm font-semibold border bg-cyan-500/20 border-cyan-400/50 hover:bg-cyan-500/30">📊 Suivi Motion Vid (disque, file)</button>
      </div>

      <div className="flex gap-2 mb-5">
        {FILTERS.map(f => (
          <button key={f.key} onClick={() => setFilter(f.key)}
            className={`px-4 py-1.5 rounded-full text-sm border transition ${filter === f.key ? 'bg-blue-500/30 border-blue-400/60' : 'bg-white/5 border-white/10 text-gray-300 hover:bg-white/10'}`}>
            {f.label}
            {f.key === 'pending' && counts[mod] > 0 && <span className="ml-2 inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 rounded-full bg-amber-400 text-[#1b1204] text-[11px] font-black">{counts[mod]}</span>}
          </button>
        ))}
      </div>

      {error && <p className="mb-4 text-sm text-rose-300 bg-rose-500/10 border border-rose-500/30 rounded-xl px-4 py-3">{error}</p>}

      {loading ? (
        <div className="py-10 flex justify-center"><Loader2 className="w-6 h-6 animate-spin" /></div>
      ) : orders.length === 0 ? (
        <p className="text-gray-400 text-sm py-8 text-center">Aucune commande {FILTERS.find(f => f.key === filter).label.toLowerCase()}.</p>
      ) : (
        <div className="space-y-3">
          {orders.map(o => (
            <div key={o.$id} className="bg-white/5 border border-white/10 rounded-2xl p-4 flex flex-wrap items-center justify-between gap-3">
              <div className="min-w-0">
                <p className="font-semibold break-all flex items-center gap-2 flex-wrap">{o.user_email || o.user_id} <PaymentMethodBadge method={o.method} />{o.plan === 'sub' && <span className="px-2 py-0.5 rounded-full bg-amber-400 text-[#1b1204] text-[11px] font-black">♾ ABONNEMENT ILLIMITÉ 30 j</span>}</p>
                <p className="text-xs text-blue-200 mt-0.5">
                  {Number(o.amount_ar).toLocaleString('fr-FR')} Ar · réf. <b>{o.payment_ref}</b>{o.plan === 'sub' && ' · Valider active 30 jours illimités (le solde n’est pas crédité)'}
                </p>
                <p className="text-xs text-gray-400 mt-0.5">Déclaré le {fmtDate(o.created_at)}</p>
                {o.status === 'rejected' && o.admin_note && <p className="text-xs text-rose-300 mt-0.5">Motif : {o.admin_note}</p>}
              </div>
              {o.status === 'pending' && (
                <div className="flex gap-2">
                  <button onClick={() => validate(o.$id)} disabled={actingOn === o.$id}
                    className="px-3.5 py-2 rounded-xl bg-emerald-500/20 border border-emerald-500/40 text-emerald-200 text-sm font-semibold hover:bg-emerald-500/30 disabled:opacity-40 transition flex items-center gap-1.5">
                    {actingOn === o.$id ? <Loader2 className="w-4 h-4 animate-spin" /> : <CheckCircle className="w-4 h-4" />} Valider
                  </button>
                  <button onClick={() => reject(o.$id)} disabled={actingOn === o.$id}
                    className="px-3.5 py-2 rounded-xl bg-rose-500/20 border border-rose-500/40 text-rose-200 text-sm font-semibold hover:bg-rose-500/30 disabled:opacity-40 transition flex items-center gap-1.5">
                    <XCircle className="w-4 h-4" /> Refuser
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
